export const extractUrlBySize = (image: Image, size: string) => {
    return (image.attributes.formats && image.attributes.formats[size]) ? image.attributes.formats[size].url : image.attributes.url;
}
